import React from "react";
import { Typography, Box, Switch, Button } from "@mui/material";
import { IProductParams } from "../../model";
import { useNavigate, useParams } from "react-router-dom";
import "./styles1.css";

const CuVoSuperAdminAccuracyReport = (props: any) => {
  const { productId, versionId } = useParams();
  const navigate = useNavigate();

  const { productParams } = props;

  const handleOpenAccuracyReport = () => {
    //alert("handleOpenAccuracyReport -> Reports")
    // const product = productParams?.products?.[0];
    navigate(`/reports/`);
    //navigate(`/report/`);

    // const stateObj = { };
    // navigate(`/view-tickets/${4}`, { state: stateObj });
  };

  const handleRedirectArcticlsViewAll = () => {
    const stateObj = {
      tabType: "ticketMetrics",
    };
    navigate(`/articles`, { state: stateObj });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      className="platform-card-container"
    >
      <Box
        display="flex"
        justifyContent="end"
        sx={{
          flex: 1,
          backgroundColor: "transparent",
        }}
      ></Box>
      <Box
        display="flex"
        justifyContent="space-between"
        sx={{
          marginBottom: "0px",
          marginTop: "0px",
          marginLeft: "5px",
        }}
      >
        <Box
          sx={{
            "& svg": {
              color: "#2858D3",
              fontSize: "2.5rem",
            },
            display: "flex",
            justifyContent: "left",
          }}
        >
          <svg
            width="336"
            height="38"
            viewBox="0 0 336 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="38" height="38" rx="19" fill="#2858D3" />
            <path
              d="M19.4999 24.7806L15.681 14.9512L13.9913 19.2888C13.8989 19.526 13.6704 19.6822 13.4158 19.6822H10.57C10.2552 19.6822 10 19.427 10 19.1122C10 18.7974 10.2552 18.5422 10.57 18.5422H13.059L15.1282 13.2193C15.3242 12.7151 16.0376 12.7152 16.2335 13.2194L20.051 23.0452L22.8613 15.8688C23.058 15.3662 23.7693 15.3665 23.9657 15.8692L25.01 18.5422H27.48C27.7948 18.5422 28.05 18.7974 28.05 19.1122C28.05 19.427 27.7948 19.6822 27.48 19.6822H24.6527C24.3984 19.6822 24.1701 19.5263 24.0775 19.2894L23.414 17.5922L20.6049 24.7817C20.4082 25.2851 19.6956 25.2844 19.4999 24.7806Z"
              fill="white"
            />
          </svg>
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent="left"
        alignItems="left"
        sx={{
          height: "28px",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            marginLeft: "5px",
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          Accuracy Report
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="left"
        alignItems="left"
        sx={{
          height: "40px",
          marginLeft: "5px",
          marginTop: "7px",
          width: "96%",
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            textAlign: "left",
            color: "#8d919f",
            fontWeight: 400,
          }}
        >
          This report is run to analyse the chatbot’s accuracy by analysing the
          real world responses with ChatGPT 4o
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="left"
        flexDirection="column"
        alignItems="left"
        sx={{
          marginTop: "30px",
        }}
      >
        <Box
          display="flex"
          flexDirection="row"
          className="feature-config-btn-parent"
        >
          <Button
            className="feature-config-btns"
            variant="text"
            onClick={() => handleOpenAccuracyReport()}
            sx={{
              fontSize: "12px",
              backgroundColor: "transparent",
            }}
          >
            Configure
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CuVoSuperAdminAccuracyReport;
